import React, {
  useState,
  useRef,
  useMemo,
  useCallback,
  useEffect,
} from "react";
import {
  MapContainer,
  TileLayer,
  useMap,
  Marker,
  Tooltip,
} from "react-leaflet";
import L from "leaflet";
import { observer } from "mobx-react-lite";
import "leaflet/dist/leaflet.css";
import "leaflet-contextmenu";
import "leaflet-contextmenu/dist/leaflet.contextmenu.css";
import "leaflet-geosearch/dist/geosearch.css";
import { GeoSearchControl, GoogleProvider } from "leaflet-geosearch";

const colorIcon = (color = "blue") =>
  new L.Icon({
    iconUrl: `https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-${color}.png`,
    shadowUrl:
      "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  }); //

const SearchField = ({ marker, setCenter }) => {
  const map = useMap();
  const provider = new GoogleProvider({
    params: {
      key: "AIzaSyBwJBwk1n-rtXghyTgY_f-moRQ9YIqyiNY",
      language: "ua",
      region: "ua",
    },
  });

  // @ts-ignore
  const searchControl = new GeoSearchControl({
    provider: provider,
    showMarker: false,
    style: "bar",
    notFoundMessage: "Адреса не знайдена",
    searchLabel: "Введіть адресу",
  });

  searchControl.onSubmit = (result) => {
    if (result.data) {
      const x = Number(result.data.x || 0);
      const y = Number(result.data.y || 0);
      marker.setLocation(y, x);
      setCenter([y, x]);
    }
  };

  useEffect(() => {
    map.addControl(searchControl);
    return () => map.removeControl(searchControl);
  }, []);

  return null;
};

const ChangeView = ({ center, zoom }) => {
  const map = useMap();
  map.setView(center, zoom);
  return null;
};

const DraggableMarker = ({ item, setCurrentMarker, drag }) => {
  const [draggable, setDraggable] = useState(false);
  const markerRef = useRef(null);
  const eventHandlers = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current;
        if (marker != null) {
          item.setLocation(
            Number(marker.getLatLng().lat || 0),
            Number(marker.getLatLng().lng || 0)
          );
        }
      },
    }),
    []
  );

  const contextMenu = {
    contextmenu: true,
    contextmenuItems: [
      {
        text: "Режим редактування",
        callback: () =>
          setDraggable((prev) => {
            setCurrentMarker(!prev ? item : null);
            return !prev;
          }),
        contex: this,
      },
    ],
    draggable,
    eventHandlers,
    icon: colorIcon(draggable ? "green" : "blue"),
  };

  return (
    <Marker
      icon={colorIcon(item.color)}
      contextmenu={false}
      {...(drag && contextMenu)}
      position={[item.latitude, item.longitude]}
      ref={markerRef}
    >
      <Tooltip direction="top" offset={[0, -20]} opacity={1}>
        <span>{item.name}</span>
      </Tooltip>
    </Marker>
  );
};

const Map = observer(
  ({
    center = [40, 30],
    zoom = 13,
    height = 900,
    marckers = [],
    setCenter,
    drag = false,
  }) => {
    const [currentMarker, setCurrentMarker] = useState(null);
    return (
      <div style={{ height: "100%" }}>
        <MapContainer
          center={center}
          zoom={zoom}
          style={{ height: "100%", width: "100%" }}
          scrollWheelZoom={false}
          scrollWheelZoom={true}
        >
          <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {!!currentMarker && (
            <SearchField marker={currentMarker} setCenter={setCenter} />
          )}
          <ChangeView
            center={
              currentMarker
                ? [currentMarker.latitude, currentMarker.longitude]
                : center
            }
          />
          {marckers.map((item, index) => (
            <DraggableMarker
              drag={drag}
              key={item.uuid}
              item={item}
              setCurrentMarker={setCurrentMarker}
            />
          ))}
        </MapContainer>
      </div>
    );
  }
);

export default Map;
